import { useApi } from './useApi';
import { url } from '../../utils/confserveur';

/** Le serveur renvoie `{"ids": null}` : tous les attendus ont leurs prérequis. */
export const TOUS_LES_ATTENDUS = 'tous';

/**
 * Les attendus dont les prérequis sont actifs (`GET /themes/attendus-avec-arbre/`,
 * 11/10/2026), en `Set` ; `TOUS_LES_ATTENDUS` si le serveur renvoie `null`.
 * `null` tant que la liste n'est pas chargée, ou en cas d'échec : aucun
 * prérequis, par prudence (13/10/2026).
 *
 * La liste ne limite QUE les prérequis : l'arbre de la popup, le bilan ciblé,
 * donc le diagnostic et les groupes. Tous les attendus restent proposés dans
 * la popup ; leurs exerciseurs, c'est `generators/ouverture.js` qui décide
 * (13/10/2026 : la liste masquait aussi les autres attendus, ce n'était pas
 * voulu).
 */
export const useAttendusAvecArbre = () => {
  const { data, isError } = useApi(`${url}themes/attendus-avec-arbre/`, null);
  if (isError || !data || typeof data !== 'object' || !('ids' in data)) return null;
  if (data.ids === null) return TOUS_LES_ATTENDUS;
  return Array.isArray(data.ids) ? new Set(data.ids) : null;
};

/** L'attendu a-t-il ses prérequis actifs, d'après la liste rendue par `useAttendusAvecArbre` ? */
export const prerequisActifs = (liste, attenduId) => attenduId != null
  && (liste === TOUS_LES_ATTENDUS || (liste instanceof Set && (liste.has(attenduId) || liste.has(Number(attenduId)))));
